import React, { FC, useMemo } from 'react'

import { Txt } from 'src/components/atoms'
import { ProjectStatus, SearchRefinementIcon } from 'src/components/molecules'
import { AssignedProjectSearch } from 'src/components/organisms'

import { useGetProjectStatuses, useProjectStatus } from 'src/hooks'
import { AssignedProjectSearchContentEntity, ProjectStatusType } from 'src/types'

type Props = {
  editButtonId: string
  cancelButtonId: string
  searchContent: AssignedProjectSearchContentEntity | null
  allAssignedProjectCount: number
  displayedProjectStatuses: Pick<ProjectStatusType, 'name'>[]
  onUpdateSearchContent: (searchContent: AssignedProjectSearchContentEntity | null) => void
  className?: string
}

/**
 * ユーザー詳細の検索や表示しているプロジェクト数を表示するエリア
 * UserAssignProjects周りが肥大化してしまうため分割したコンポーネント
 */
export const UserAssignProjectsSearchArea: FC<Props> = ({
  editButtonId,
  cancelButtonId,
  searchContent,
  allAssignedProjectCount,
  displayedProjectStatuses,
  onUpdateSearchContent,
  className,
}) => {
  const { getHasArchived } = useProjectStatus()
  const { projectStatuses } = useGetProjectStatuses()

  const isSearchEnabled = useMemo(() => {
    if (searchContent === null) {
      return false
    }

    const { word, selectedStatuses, selectedCompassRoles } = searchContent

    const isEnabledWord = word !== undefined && word !== ''
    const isEnabledStatus = selectedStatuses !== undefined && selectedStatuses.length > 0
    const isEnabledCompassRole =
      selectedCompassRoles !== undefined && selectedCompassRoles.length > 0

    return isEnabledWord || isEnabledStatus || isEnabledCompassRole
  }, [searchContent])

  return (
    <div className={className}>
      <div className="tw-flex tw-items-center tw-gap-s0 tw-ml-auto tw-w-fit">
        <div className="tw-flex tw-gap-s-3">
          {isSearchEnabled && <SearchRefinementIcon searchEnabled={isSearchEnabled} />}
          <Txt sizeType="s" className="tw-font-bold tw-text-roovPrimary-default">
            {displayedProjectStatuses.length}
          </Txt>
          <Txt sizeType="s" className="tw-text-standardText-disable">
            /
          </Txt>
          <Txt sizeType="s" className="tw-text-standardText-secondary">
            {allAssignedProjectCount}
          </Txt>
        </div>
        <AssignedProjectSearch
          editButtonId={editButtonId}
          cancelButtonId={cancelButtonId}
          searchContent={searchContent}
          updateSearchContent={onUpdateSearchContent}
        />
      </div>

      <ProjectStatus
        projectStatusNames={displayedProjectStatuses}
        hasArchived={getHasArchived(projectStatuses)}
        className="tw-ml-auto tw-w-fit tw-mt-s1"
      />
    </div>
  )
}
